import { ref } from 'vue'
import { useMutationObserver, useResizeObserver, useScroll } from '@vueuse/core'

// Scroll state and paging for a horizontal row of equal cards; `track` is the scroller's ref.
export function useCarousel (track) {
  const { arrivedState, measure } = useScroll(track)
  // Whether the cards run past the box at all; a row that fits has nothing to page.
  const overflowing = ref(false)

  const update = () => {
    measure()
    overflowing.value = !!track.value && track.value.scrollWidth - track.value.clientWidth > 1
  }

  // Pages by the cards that fit, so a half-shown card leads the next page.
  const scrollByPage = (direction) => {
    const card = track.value?.firstElementChild
    if (!card) return

    const gap = parseFloat(getComputedStyle(track.value).columnGap) || 0
    const step = card.offsetWidth + gap
    const perPage = Math.max(1, Math.floor((track.value.clientWidth + gap) / step))

    track.value.scrollBy({ left: direction * perPage * step, behavior: 'smooth' })
  }

  useResizeObserver(track, update)
  // Cards added or removed (a page loaded, a step finished) move the ends without a scroll event.
  useMutationObserver(track, update, { childList: true })

  return { arrivedState, overflowing, scrollByPage }
}
